module.exports = __webpack_public_path__ + "static/media/Fabriques_IlotF_synthese_5.8a934b64.webp";